(function () {
    'use strict';

    angular
        .module('app')
        .controller('CampaignsListController', CampaignsListController);

    CampaignsListController.$inject = ['API', 'alert', 'debug', 'ListViewSearchExtension', '$stateParams', 'campaignCategory', 'i18n',];

    function CampaignsListController(API, alert, debug, ListViewSearchExtension, $stateParams, campaignCategory, i18n) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {
            campaignType: '',
            sort: 'latestFirst',
        };
        vm.loadingState = {
            campaignIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.keyUp = keyUp;
        vm.loadResources = loadResources;
        vm.campaignTypes = [];
        vm.campaigns = [];

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }
            loadCampaignTypes();
            loadResources(true);
        }

        function openRemoveModal(campaign) {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.Campaign.recycle({ id: campaign.id }).$promise;

                removePromise.then(function() {
                    var index = vm.campaigns.findIndex(function(item) {
                        return item.id === campaign.id;
                    });
                    vm.campaigns.splice(index, 1);
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('CAMPAIGN_RECYCLED') });
                }, function() {});
            }, function() {});
        }

        function loadCampaignTypes() {
            vm.campaignTypes = campaignCategory.get();
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
                'sort': '',
                expand: 'subscriptionPlan'
            };

            if (vm.listObject.filter.sort) {
                switch (vm.listObject.filter.sort) {
                    case 'latestFirst':
                        searchObject.sort = '-created_at';
                        break;
                    case 'oldestFirst':
                        searchObject.sort = 'created_at';
                        break;
                    case 'alphabetAscending':
                        searchObject.sort = '-name';
                        break;
                    case 'alphabetDescending':
                        searchObject.sort = 'name';
                        break;
                    case 'mostTrialDays':
                        searchObject.sort = '-trial_extension_days';
                        break;
                    case 'leastTrialDays':
                        searchObject.sort = 'trial_extension_days';
                        break;

                    default:
                        break;
                }
            }

            if (vm.listObject.filter.campaignType) {
                searchObject.category = vm.listObject.filter.campaignType;
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.Campaign.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.Campaign.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.campaignIsLoading = true;
                promise.then(function (response) {
                    vm.campaigns = response.items;
                    debug.log(response);
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.campaignIsLoading = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                loadResources(true);
            }
        }
    }
})();